import classnames from 'classnames';
import styles from "./SkeletonIndicator.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var SkeletonIndicator = function SkeletonIndicator(_ref) {
  var _ref$barWidths = _ref.barWidths,
    barWidths = _ref$barWidths === void 0 ? ['100%', '60%', '80%'] : _ref$barWidths,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align;
  var renderBars = function renderBars() {
    var skeleton = [];
    if (barWidths) {
      for (var i = 0; i < barWidths.length; i += 1) {
        skeleton.push( /*#__PURE__*/_jsx("div", {
          style: {
            width: barWidths[i]
          },
          className: classnames(styles[size], styles.skeletonBar)
        }, i));
      }
    }
    return skeleton;
  };
  return /*#__PURE__*/_jsx("div", {
    style: {
      alignItems: align === 'left' ? 'flex-start' : 'flex-end'
    },
    className: classnames(styles.skeleton, className),
    children: renderBars()
  });
};